
import './unautherized.css';

const Unauthorized = () => {
  return (
    <div className="unauth-container">
      <div className="unauth-card">
        {/* Visual Icon using SVG */}
        <div className="unauth-icon-wrapper">
          <svg 
            viewBox="0 0 24 24" 
            width="48" 
            height="48" 
            stroke="currentColor" 
            strokeWidth="1.5" 
            fill="none" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          >
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
        </div>

        <h1 className="unauth-title">Access Denied</h1>
        <p className="unauth-message">
          You don't have the necessary permissions to access this page. 
          If you believe this is an error, please contact support.
        </p>

        <span className="unauth-code">Error 403: Forbidden</span>
      </div>
    </div>
  );
};

export default Unauthorized;